import Col from "@visa/vds/col";
import Form from "@visa/vds/form";
import FormControl from "@visa/vds/form-control";
import Icon from "@visa/vds/icon";
import Input from "@visa/vds/input";
import InputOption from "@visa/vds/input-option";
import Td from "@visa/vds/td";
import Tr from "@visa/vds/tr";
import { DateHelper } from "_helpers/DateHelper";
import { SubscriptionHelper } from "_helpers/SubscriptionHelper";
import MCSPagedTable from "components/MCSPagedTable";
import SubscriptionStatusBadge from "components/subscription/SubscriptionStatusBadge";
import { cloneDeep } from "lodash";
import React, { useState } from "react";

function SubscriptionsTable(props) {
  const tableData = props.tableData;
  const [selectedPage, setSelectedPage] = useState(1);
  const [ordered, setOrdered] = useState(props.ordered);
  const [isDsc, setDsc] = useState(props.isDsc);
  const filter = props.filter;
  const setFilter = props.setFilter;
  const [typingTimeOut, setTypingTimeout] = useState({ name: "", timeout: 0 });

  let colHeaders = [
    { displayName: "Purchased Date", name: "CreatedOn", orderable: true },
    { displayName: "Product Name", name: "ProductName", orderable: true },
    { displayName: "Subscription Name", name: "SubscriptionName", orderable: true },
    { displayName: "Subscription Start Date", name: "StartDate", orderable: true },
    { displayName: "Subscription Last Date", name: "EndDate", orderable: true },
    { displayName: "Business Name", name: "OrganizationName", orderable: false },
    { displayName: "Order Reference", name: "OrderId", orderable: false },
    { displayName: "Purchased By", name: "CreatedBy", orderable: true },
    { displayName: "Status", name: "SubscriptionStatusName", orderable: false },
    { displayName: "", name: "action", orderable: false },
  ];

  const fetch = async (page, sortBy, desc, filter) => {
    await props.fetch(page, filter, sortBy, desc);
  };

  const handleSearchChange = async (searchBy) => {
    setSelectedPage(1);
    let searchFilter = processParams(filter);
    searchFilter.search = searchBy;
    await fetch(1, ordered, isDsc, searchFilter);
  };

  function processParams(filter) {
    if (filter === null) return null;
    let process = cloneDeep(filter);
    return process;
  }

  const sortData = async (orderBy = null, dsc = false) => {
    await fetch(selectedPage, orderBy, dsc, filter);
  };

  const fetchDataOnPageChange = (page) => {
    setSelectedPage(page);
    fetch(page, ordered, isDsc, filter);
  };

  const handleKeyPress = (event) => {
    setFilter({ ...filter, search: event.target.value });
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearchChange(event.target.value);
      clearTimeout(typingTimeOut.timeout);
    }
  };

  const handleAutoSearch = (searchValue) => {
    setFilter({ ...filter, search: searchValue });
    if (typingTimeOut.timeout) {
      clearTimeout(typingTimeOut.timeout);
    }
    setTypingTimeout({
      name: searchValue,
      timeout: setTimeout(function () {
        handleSearchChange(searchValue);
      }, 1500),
    });
  };

  function getSubscriptionTypeDesc(subscriptionType) {
    let desc =
      SubscriptionHelper.GetSubscriptionTypeDescription(subscriptionType);
    if (desc != null && desc != "") return " (" + desc + ")";
    return "";
  }



  return (
    <>
      <Col lg={6} md={8} sm={8} alignEnd textAlign="right" noRightGutter={true}>
        <Form>
          <FormControl
            position="right"
            space="fifty"
            style={{ marginTop: "20px" }}
          >
            <Input
              name="search"
              value={filter.search}
              helpText="Order Reference"
              showHelpText
              onKeyPress={handleKeyPress}
              onChange={(e) => handleAutoSearch(e.target.value)}
            >
              <InputOption>
                <Icon
                  name="search"
                  resolution="low"
                  style={{ cursor: "pointer" }}
                />
              </InputOption>
            </Input>
          </FormControl>
        </Form>
      </Col>
      {tableData && (
        <MCSPagedTable
          size={"compact"}
          colHeaders={colHeaders}
          usePagination={true}
          ordered={ordered}
          setOrdered={setOrdered}
          sortData={sortData}
          isDsc={isDsc}
          setDsc={setDsc}
          selectedPage={selectedPage}
          setSelectedPage={fetchDataOnPageChange}
          totalPages={props.totalPages}
          totalCount={props.totalCount}
          pageSize={props.pageSize}
          tableData={
            tableData &&
            tableData.map((row, key) => (
              <Tr key={key}>
                <Td id={key + " purchased-date"}>{DateHelper.ToFormattedDate(row.createdOn)}</Td>
                <Td id={key + " product-name"}>{row.productName}</Td>
                <Td id={key + " subscription-name"}>
                  {row.subscriptionName +
                    getSubscriptionTypeDesc(row.subscriptionType)}
                </Td>
                <Td id={key + " start-date"}>{DateHelper.ToFormattedDate(row.startDate)}</Td>
                <Td id={key + " end-date"}>{DateHelper.ToFormattedDate(row.endDate)}</Td>
                <Td id={key + " org-name"}>{row.organizationName}</Td>
                <Td id={key + " order-Id"}>{row.orderId}</Td>
                <Td id={key + " created-by"}>{row.createdBy}</Td>
                <Td class="word-nobreak" id={key + " subscription-status"}>
                  <SubscriptionStatusBadge
                    startDate={row.startDate}
                    status={row.subscriptionStatus}
                    statusName={row.subscriptionStatusName}
                  />
                </Td>
                <Td style={{ "text-align": "center" }}>
                  <Icon
                    id = {key + " action"}
                    data-id={row.id}
                    onClick={() => props.handleClickAction(row)}
                    className="vss-clickable-icon"
                    name="settings"
                    resolution="low"
                  />
                </Td>
              </Tr>
          ))
          }
        />
      )}
    </>
  );
}

export default SubscriptionsTable;
